/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { L as Label, d as defineCustomElement$1 } from './label.js';
const IonLabel = Label;
const defineCustomElement = defineCustomElement$1;
export { IonLabel, defineCustomElement };